<template>
  <div>
    <v-timeline class="checklistTimeline pt-0" dense clipped>
      <v-timeline-item
        v-for="(item, index) in data"
        :key="index"
        class="mb-8 pb-0"
        fill-dot
        color="cardSurface"
        icon-color="bodyBG"
      >
        <template v-slot:icon>
          <h2>{{ index + 1 }}</h2>
        </template>
        <StandardCard
          :title="getTitle(item.type, index)"
          remove-mb
          remove-divider
        >
          <div class="pa-4 pt-0">
            <v-runtime-template
              class="lineChange"
              :template="convertBlueprintsDirectives(item.html)"
              :templateProps="{ downloadBluePrint }"
            ></v-runtime-template>
            <ChecklistType :item="item" :disabled="readonly" />
            <v-divider class="my-3"></v-divider>
            <div class="d-flex justify-end align-end">
              <div
                v-if="
                  $vuetify.breakpoint.smAndDown &&
                  value.discrepancyType === 2 &&
                  item.info
                "
                class="pr-10"
              >
                <v-btn
                  small
                  color="warning"
                  depressed
                  @click="setItemActionInfo(item)"
                >
                  <v-icon left>mdi-help-circle-outline</v-icon>
                  Opprettet tiltak
                </v-btn>
              </div>

              <div v-if="value.discrepancyType === 2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      color="primary"
                      depressed
                      :disabled="
                        !isAssignedTo ||
                        !!item.regLineId ||
                        (!!item.aberration && value.discrepancyType !== 2)
                      "
                      @click="addAberrationOrActionOrRegLine(item)"
                    >
                      <v-icon left>mdi-alert-outline</v-icon>
                      {{ getChekckListDiscrepancy }}
                    </v-btn>
                  </template>
                  <span>{{ item.actionsInfo }}</span>
                </v-tooltip>
              </div>
              <div v-if="value.discrepancyType !== 2">
                <v-btn
                  small
                  color="primary"
                  depressed
                  :disabled="
                    !isAssignedTo || !!item.regLineId || !!item.aberration
                  "
                  @click="addAberrationOrActionOrRegLine(item)"
                >
                  <v-icon left>mdi-alert-outline</v-icon>
                  {{ getChekckListDiscrepancy }}
                </v-btn>
              </div>
            </div>
          </div>
        </StandardCard>
      </v-timeline-item>
    </v-timeline>
    <AberrationDialog v-model="showAberrationDialog" @save="saveAberration" />
    <NewComplaintDialog v-model="showComplaintDialog" @save="saveComplaint" />
    <ActionDialog
      v-model="showActionDialog"
      :title="getActionTitle"
      :action.sync="action"
      :actionsTypes="actionsTypes"
      :actionSeverities="actionSeverities"
      @save="saveAction"
    ></ActionDialog>

    <InfoDialog
      v-model="showActionInfo"
      title="Sjekkliste tiltak"
      :infoText="infoText"
    />
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import ibmApi from "@/api/ibmApi";
import aberrationApi from "@/api/aberrationApi";
import complaintApi from "@/api/complaintApi";
import { saveFile } from "@/helpers/files";

import VRuntimeTemplate from "v-runtime-template";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import ChecklistType from "@/components/checklists/checklist/children/ChecklistType.vue";
import AberrationDialog from "@/components/shared/dialog/AberrationDialog.vue";
import NewComplaintDialog from "@/components/shared/dialog/NewComplaintDialog.vue";
import notification from "@/helpers/notification";
import ActionDialog from "@/components/shared/dialog/AberrationActionDialog.vue";
import InfoDialog from "@/components/shared/dialog/InfoDialog.vue";

export default Vue.extend({
  name: "ChecklistTimeline",
  props: {
    value: {
      required: true,
    },
    isCompleted: {
      type: Boolean,
      default: false,
    },
    isAssignedTo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getData: {},
      showAberrationDialog: false,
      showComplaintDialog: false,
      item: null,
      showActionDialog: false,
      actionCount: 0,
      actionsTypes: [],
      actionSeverities: [],
      action: {
        attachments: [],
        timeLimit: new Date().toISOString().slice(0, 10),
      },
      validForm: true,
      showActionInfo: false,
      infoText: "",
    };
  },
  methods: {
    downloadBluePrint(id) {
      ibmApi.download(id, true).then(saveFile);
    },
    convertBlueprintsDirectives(html) {
      //Change from angular to vue click
      var text = html.replace(/ng-click/gi, "@click");
      //Change method from angular model. to vue
      text = text.replace(/model./gi, "");
      //remove href
      text = text.replace(/href=""/gi, ``);
      //remove open i nye tab
      text = text.replace(/target="_blank"/gi, "");

      text = "<div>" + text + "</div>";
      return text;
    },
    getTitle(type, index) {
      switch (type) {
        case 0:
          return index + 1 + ". " + "Ja/Nei";
        case 1:
          return index + 1 + ". " + "Tekst spørsmål";
        case 2:
          return index + 1 + ". " + "Velg en";
        case 3:
          return index + 1 + ". " + "Flervalg";
        case 4:
          return index + 1 + ". " + "Dato";
        case 5:
          return index + 1 + ". " + "Fil";
        case 6:
          return index + 1 + ". " + "Tall spørsmål";
        case 7:
          return index + 1 + ". " + "Desimaltall";
        case 8:
          return index + 1 + ". " + "Tekstfelt";
        case 9:
          return index + 1 + ". " + "Spørsmål";
        default:
          return "";
      }
    },
    async addAberrationOrActionOrRegLine(item) {
      switch (this.value.discrepancyType) {
        case 0:
          this.item = item;
          this.showAberrationDialog = true;
          return;
        case 1:
          this.item = item;
          this.showComplaintDialog = true;
          return;
        case 2:
          this.item = item;
          await aberrationApi
            .getChecklistAbrrebationActions({
              checklistId: this.item.checklistId,
              checklistItemId: this.item.id,
              aberrationId: this.item?.aberrationId,
            })
            .then((response) => {
              this.action.aberrationId =
                response.aberrationActions.aberrationId;
              this.actionsTypes = response.aberrationActionTypes;
              if (response.aberrationActionTypes.length === 1) {
                this.action.actionsType = response.aberrationActionTypes[0].id;
              }
              this.actionSeverities = response.actionSeverities;
              this.actionCount =
                response.aberrationActions &&
                response.aberrationActions?.totalActions
                  ? response.aberrationActions.totalActions + 1
                  : 1;
              this.showActionDialog = true;
            });
          return;
        default:
          return "";
      }
    },

    saveAberration(aberration) {
      if (aberration) {
        aberration.projTable = this.value.projectId;
        aberration.projPhase = this.value.houseId;
        aberration.projSectionId = this.value.sectionId;
        aberration.aberrationTypeId = 43; //Avvik i sjekkliste
        aberration.category = 1; //avvik

        var checklistItemAberrationRequest = {
          aberration: aberration,
          checklistItem: this.item,
          skipQaManagerNotification: true,
        };

        aberrationApi
          .createFromChecklistItem(checklistItemAberrationRequest)
          .then((response) => {
            notification.success("Avvik opprettet!");
            this.$set(this.item, "regLine", response);
            this.showAberrationDialog = false;
          });
      }
    },
    async saveComplaint(complaint) {
      if (complaint) {
        var newComplaint = {
          attachments: complaint.attachments,
          name: complaint.name,
          txt: complaint.txt,
          contactId: complaint.contactId,
          contactPersonId: complaint.contactPersonId,

          regHeaderSource: "9", //Kilde sjekkliste

          projRegistrationProjTable: this.value.projectId,
          projRegistrationPhase: this.value.houseId,
          projRegistrationSection: this.value.sectionId,
          regLineCategoryId: 1,
          regHeaderDate: moment(),
          regHeaderType: 0,
          regHeaderStatus: 6,
          lineStatus: 6,
          timeLimit: moment(),
        };

        var checklistItemRegLineRequest = {
          regLine: newComplaint,
          checklistItem: this.item,
          skipQaManagerNotification: true,
        };
        this.showComplaintDialog = false;
        await complaintApi
          .createFromChecklistItem(checklistItemRegLineRequest)
          .then((response) => {
            notification.success("Reklamasjon opprettet!");
            this.$set(this.item, "regLineId", response.id);
            this.showComplaintDialog = false;
          });
      }
    },
    async saveAction() {
      await aberrationApi
        .saveChecklistAbrrebationActions({
          id: this.item.id,
          checklistId: this.item.checklistId,
          aberrationId: this.action.aberrationId,
          timeLimit: this.action.timeLimit,
          aberrationActionType: this.action.actionsType,
          action: this.action,
        })
        .then(() => {
          notification.success(
            `Tiltak opprettet for sjekklistepunkt ${this.item?.txt}`
          );

          this.actionCount = this.actionCount + 1;
          this.resetAction();
          this.showActionDialog = false;
          this.$emit("refresh");
        })
        .catch(() => {
          notification.error("Noe gikk galt ved opprettelse av titak");
        });

      this.showActionDialog = false;
    },
    resetAction() {
      this.action.title = "";
      this.action.description = "";
      this.action.responsibleId = null;
      this.action.timeLimit = "";
      this.action.attachments = [];
      this.validForm = true;
    },
    setItemActionInfo(item) {
      if (item) {
        this.infoText = item.info
          ? `Avvik opprettet: #${item.aberration.aberrationId}. <br> Tiltak opprettet: ` +
            item.info
          : "";
      }
      this.showActionInfo = true;
    },
  },
  computed: {
    data: {
      get() {
        if (this.value) {
          return this.value.items;
        }
        return [];
      },
    },
    readonly() {
      return this.isCompleted || !this.isAssignedTo;
    },
    getChekckListDiscrepancy() {
      switch (this.value.discrepancyType) {
        case 0:
          return "Opprett avvik";
        case 1:
          return "Opprett reklamasjon";
        case 2:
          return "Opprett tiltak";
        default:
          return "";
      }
    },
    getActionTitle() {
      return `Tiltak #${this.actionCount} for sjekklistpunkt ${this.item?.txt}`;
    },
  },
  components: {
    VRuntimeTemplate,
    StandardCard,
    ChecklistType,
    AberrationDialog,
    NewComplaintDialog,
    ActionDialog,
    InfoDialog,
  },
});
</script>

<style lang="scss" scoped>
.lineChange {
  white-space: pre-line;
}
</style>

<style lang="scss">
@media (max-width: 600px) {
  .checklistTimeline {
    &:before {
      display: none;
    }
    .v-timeline-item {
      .v-timeline-item__body {
        max-width: unset;
        .v-card {
          &:before {
            display: none;
          }
          &:after {
            display: none;
          }
        }
      }
      .v-timeline-item__divider {
        display: none;
      }
    }
  }
}
</style>
